(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const nok = (cents) => new Intl.NumberFormat("nb-NO", { maximumFractionDigits: 0 }).format(cents / 100) + " kr";
  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const isSizeOption = (name) => /størrelse|size/i.test(name);
  const isColorOption = (name) => /farge|colou?r/i.test(name);
  // "38-39" og "38" sorteres etter første tall
  const bySize = (a, b) => parseFloat(a) - parseFloat(b) || a.localeCompare(b);
  const sized = (url, w) => (url ? url + (url.includes("?") ? "&" : "?") + "width=" + w : "");

  // ---------- Produktside ----------
  function buildProduct(json) {
    const names = json.options.map((o) => (typeof o === "string" ? o : o.name));
    const variants = json.variants.map((v) => ({
      id: v.id,
      available: v.available,
      price: v.price,
      options: Object.fromEntries(names.map((n, i) => [n, v[`option${i + 1}`]])),
      image: v.featured_image ? v.featured_image.src : null
    }));
    const options =
      variants.length > 1
        ? names.map((name) => {
            const values = [...new Set(variants.map((v) => v.options[name]))];
            return { name, values: isSizeOption(name) ? values.sort(bySize) : values };
          })
        : [];
    return { title: json.title, options, variants, sel: {} };
  }

  // Et valg er tilgjengelig hvis en variant på lager matcher det og alle valg i tidligere alternativer
  function valueAvailable(p, optIndex, value) {
    const name = p.options[optIndex].name;
    return p.variants.some(
      (v) => v.available && v.options[name] === value && p.options.slice(0, optIndex).every((o) => !p.sel[o.name] || v.options[o.name] === p.sel[o.name])
    );
  }

  function selectedVariant(p) {
    if (!p.options.length) return p.variants[0];
    return p.variants.find((v) => p.options.every((o) => v.options[o.name] === p.sel[o.name])) || null;
  }

  const root = $("[data-pdp]");
  if (root) {
    const p = buildProduct(JSON.parse($("[data-product]").textContent));
    const swatches = JSON.parse($("[data-swatches]").textContent || "{}");
    const colorImages = JSON.parse($("[data-color-images]")?.textContent || "{}");
    const colorOpt = p.options.find((o) => isColorOption(o.name));
    const main = $("[data-main]", root);
    const thumbs = $$("[data-thumb]", root);
    const btn = $("[data-add]", root);

    // Forhåndsvelg fargen fra lenken kunden kom fra, men la kunden velge størrelse selv
    const initial = p.variants.find((v) => String(v.id) === root.dataset.initial) || p.variants[0];
    p.options.forEach((o, i) => {
      if (o.values.length === 1) p.sel[o.name] = o.values[0];
      else if (!isSizeOption(o.name)) p.sel[o.name] = initial.options[o.name];
      if (p.sel[o.name] && !valueAvailable(p, i, p.sel[o.name])) {
        p.sel[o.name] = o.values.find((val) => valueAvailable(p, i, val)) || p.sel[o.name];
      }
    });

    function showImage(src) {
      if (!main || !src || main.dataset.src === src) return;
      main.dataset.src = src;
      main.classList.add("is-loading");
      const next = new Image();
      next.onload = () => { main.src = src; main.classList.remove("is-loading"); };
      next.src = src;
      thumbs.forEach((t) => {
        t.classList.toggle("is-active", t.dataset.src === src);
        t.setAttribute("aria-pressed", String(t.dataset.src === src));
      });
    }

    function syncGallery() {
      if (!colorOpt) return;
      const color = p.sel[colorOpt.name];
      // Vis felles bilder og bildene til valgt farge, skjul de andre fargene
      thumbs.forEach((t) => { t.hidden = Boolean(t.dataset.color) && t.dataset.color !== color; });
      const own = thumbs.find((t) => t.dataset.color === color);
      if (own) {
        own.parentElement.prepend(own);
        showImage(own.dataset.src);
      }
    }

    const optionsEl = $("[data-options]", root);
    const fitTip = optionsEl.dataset.fit || "";
    const guide = $("#sizeGuide");
    const bar = $("[data-buybar]");
    const barBtn = bar && $("[data-buybar-btn]", bar);
    const barMeta = bar && $("[data-buybar-meta]", bar);
    let state = {};

    function buyState() {
      const variant = selectedVariant(p);
      const missing = p.options.find((o) => !p.sel[o.name]);
      if (!p.variants.some((v) => v.available)) return { variant, label: "Utsolgt", soldOut: true };
      if (missing) return { variant, missing, label: `Velg ${missing.name.toLowerCase()}` };
      if (!variant || !variant.available) return { variant, label: "Ikke på lager", soldOut: true };
      return { variant, ready: true, label: `Legg i handlekurven · ${nok(variant.price)}` };
    }

    function render() {
      // Husk fokus, siden valgene tegnes på nytt
      const active = document.activeElement;
      const focusKey = active && active.dataset && active.dataset.option ? [active.dataset.option, active.dataset.value] : null;

      optionsEl.innerHTML = p.options
        .map((o, i) => {
          const color = isColorOption(o.name);
          const size = isSizeOption(o.name);
          const chosen = p.sel[o.name];
          const head =
            `<div class="option-head"><span>${esc(o.name)}: <strong>${chosen ? esc(chosen) : "velg"}</strong></span>` +
            (size && guide ? `<button type="button" class="link-btn" data-size-guide aria-haspopup="dialog">Størrelsesguide</button>` : "") +
            `</div>`;
          const buttons = o.values
            .map((val) => {
              const on = chosen === val;
              const disabled = valueAvailable(p, i, val) ? "" : "disabled";
              if (color && colorImages[val]) {
                return `<button type="button" class="tile${on ? " is-selected" : ""}" data-option="${esc(o.name)}" data-value="${esc(val)}" aria-label="${esc(val)}${disabled ? ", utsolgt" : ""}" aria-pressed="${on}" title="${esc(val)}" ${disabled}><img src="${esc(colorImages[val])}" alt="" width="76" height="76"></button>`;
              }
              return color
                ? `<button type="button" class="swatch${on ? " is-selected" : ""}" style="--c:${esc(swatches[val] || "#d9d3ca")}" data-option="${esc(o.name)}" data-value="${esc(val)}" aria-label="${esc(val)}${disabled ? ", utsolgt" : ""}" aria-pressed="${on}" title="${esc(val)}" ${disabled}></button>`
                : `<button type="button" class="size${on ? " is-selected" : ""}" data-option="${esc(o.name)}" data-value="${esc(val)}" aria-pressed="${on}" ${disabled ? `${disabled} aria-label="${esc(val)}, utsolgt"` : ""}>${esc(val)}</button>`;
            })
            .join("");
          const tip = size && fitTip ? `<p class="fit-tip">${esc(fitTip)}</p>` : "";
          const hint = `<p class="option-hint" data-hint="${esc(o.name)}" role="alert"></p>`;
          return `<div class="option" role="group" aria-label="Velg ${esc(o.name.toLowerCase())}">${head}<div class="${color ? "swatches" : "sizes"}">${buttons}</div>${tip}${hint}</div>`;
        })
        .join("");

      if (focusKey) {
        const again = $$("[data-option]", optionsEl).find((b) => b.dataset.option === focusKey[0] && b.dataset.value === focusKey[1]);
        if (again) again.focus();
      }

      state = buyState();
      if (state.variant) $("[data-price]", root).textContent = nok(state.variant.price);
      // Hovedknappen er bare aktiv når en variant på lager er valgt
      btn.disabled = Boolean(state.soldOut);
      btn.setAttribute("aria-disabled", String(!state.ready));
      btn.classList.toggle("is-waiting", !state.ready && !state.soldOut);
      btn.textContent = state.label;
      if (bar) {
        barBtn.textContent = state.ready ? "Legg i handlekurven" : state.label;
        barBtn.disabled = Boolean(state.soldOut);
        barBtn.classList.toggle("is-waiting", !state.ready && !state.soldOut);
        const picked = p.options.map((o) => p.sel[o.name]).filter(Boolean).join(" · ");
        barMeta.textContent = (state.variant ? nok(state.variant.price) : $("[data-price]", root).textContent) + (picked ? ` · ${picked}` : "");
      }
      syncGallery();
    }

    // Uten valgt størrelse viser knappen hvor kunden skal velge, i stedet for å legge noe i kurven
    function showMissing() {
      if (!state.missing) return;
      const group = $$(".option", optionsEl)[p.options.indexOf(state.missing)];
      const hint = $(`[data-hint="${CSS.escape(state.missing.name)}"]`, optionsEl);
      if (hint) hint.textContent = `Velg ${state.missing.name.toLowerCase()} først.`;
      group.scrollIntoView({ behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "center" });
      const first = $("[data-option]:not(:disabled)", group);
      if (first) first.focus({ preventScroll: true });
    }

    function buy(trigger) {
      if (state.ready) addToCart(p, state.variant, trigger);
      else showMissing();
    }

    root.addEventListener("click", (e) => {
      const thumb = e.target.closest("[data-thumb]");
      if (thumb) return showImage(thumb.dataset.src);

      if (e.target.closest("[data-size-guide]")) return guide.showModal();

      const optBtn = e.target.closest("[data-option]");
      if (optBtn) {
        const idx = p.options.findIndex((o) => o.name === optBtn.dataset.option);
        p.sel[optBtn.dataset.option] = optBtn.dataset.value;
        // Nullstill senere valg som ikke lenger finnes på lager
        p.options.slice(idx + 1).forEach((o, j) => {
          if (p.sel[o.name] && !valueAvailable(p, idx + 1 + j, p.sel[o.name])) delete p.sel[o.name];
        });
        render();
        const variant = selectedVariant(p);
        if (variant) history.replaceState(null, "", `?variant=${variant.id}`);
        return;
      }

      if (e.target.closest("[data-add]")) buy(btn);
    });

    if (guide) {
      guide.addEventListener("click", (e) => {
        // Lukk ved klikk på bakgrunnen eller lukkeknappen
        if (e.target === guide || e.target.closest("[data-close-dialog]")) guide.close();
      });
    }

    // Fast kjøpslinje på mobil når hovedknappen er ute av syne
    if (bar && "IntersectionObserver" in window) {
      barBtn.addEventListener("click", () => buy(barBtn));
      const mobile = matchMedia("(max-width: 860px)");
      let btnVisible = true;
      const update = () => {
        const show = mobile.matches && !btnVisible;
        bar.classList.toggle("is-visible", show);
        bar.setAttribute("aria-hidden", String(!show));
        barBtn.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(([entry]) => { btnVisible = entry.isIntersecting; update(); }).observe(btn);
      mobile.addEventListener("change", update);
      document.body.classList.add("has-buybar");
    }

    render();
  }

  // ---------- Filter (forsiden) ----------
  function setFilter(f) {
    const cards = $$("#productGrid .pcard");
    if (!cards.length) return false;
    const known = $$(".filter").some((b) => b.dataset.filter === f);
    if (!known) f = "alle";
    let shown = 0;
    cards.forEach((c) => {
      const show = f === "alle" || c.dataset.category === f;
      c.hidden = !show;
      shown += show;
    });
    const empty = $("#emptyFilter");
    if (empty) empty.hidden = shown > 0;
    $$(".filter").forEach((b) => {
      b.classList.toggle("is-active", b.dataset.filter === f);
      b.setAttribute("aria-pressed", String(b.dataset.filter === f));
    });
    const url = new URL(location.href);
    if (f === "alle") url.searchParams.delete("kategori");
    else url.searchParams.set("kategori", f);
    history.replaceState(null, "", url);
    return true;
  }
  $$(".filter").forEach((b) => b.addEventListener("click", () => setFilter(b.dataset.filter)));
  // Meny- og bunntekstlenker filtrerer direkte når kunden allerede er på forsiden
  $$("[data-filter-link]").forEach((a) =>
    a.addEventListener("click", (e) => {
      if (!$("#productGrid")) return;
      e.preventDefault();
      setFilter(a.dataset.filterLink);
      closeMenu();
      $("#butikk").scrollIntoView({ behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
    })
  );
  const startFilter = new URLSearchParams(location.search).get("kategori");
  if (startFilter && $("#productGrid")) setFilter(startFilter);

  // ---------- Mobilmeny ----------
  const menuBtn = $("#menuBtn");
  const nav = $("#mainNav");
  function closeMenu() {
    if (!menuBtn) return;
    menuBtn.setAttribute("aria-expanded", "false");
    nav.classList.remove("is-open");
  }
  if (menuBtn) {
    menuBtn.addEventListener("click", () => {
      const open = menuBtn.getAttribute("aria-expanded") !== "true";
      menuBtn.setAttribute("aria-expanded", String(open));
      nav.classList.toggle("is-open", open);
    });
    $$("a", nav).forEach((a) => a.addEventListener("click", closeMenu));
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && nav.classList.contains("is-open")) { closeMenu(); menuBtn.focus(); }
    });
  }

  // ---------- Gjennomsiktig meny over heroen på forsiden ----------
  const overHeader = $(".header--over");
  const hero = $(".hero");
  if (overHeader && hero) {
    let ticking = false;
    const update = () => {
      overHeader.classList.toggle("is-solid", hero.getBoundingClientRect().bottom <= overHeader.offsetHeight);
      ticking = false;
    };
    window.addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  // ---------- Handlekurv (Shopify sin egen kurv via AJAX) ----------
  const drawer = $("#cart");
  const freeShipping = Number(drawer?.dataset.freeShipping || 0);

  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: body ? "POST" : "GET",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: body ? JSON.stringify(body) : undefined
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || "Feil i handlekurven");
    return json;
  }

  function renderCart(cart) {
    const countEl = $("#cartCount");
    countEl.textContent = cart.item_count;
    countEl.toggleAttribute("data-zero", cart.item_count === 0);
    $("#cartTotal").textContent = nok(cart.total_price);
    $("#checkoutBtn").classList.toggle("is-disabled", cart.item_count === 0);

    const left = freeShipping - cart.total_price;
    const pct = freeShipping ? Math.min(100, (cart.total_price / freeShipping) * 100) : 100;
    $("#cartShipping").innerHTML =
      (left > 0 ? `Du er <strong>${nok(left)}</strong> unna fri frakt` : `Du har <strong>fri frakt</strong>`) +
      `<div class="bar"><span style="width:${pct}%"></span></div>`;

    $("#cartItems").innerHTML = cart.items.length
      ? cart.items
          .map(
            (item, i) => `
        <li class="cart-item">
          <div class="cart-thumb">${item.image ? `<img src="${esc(sized(item.image, 200))}" alt="" width="80" height="80">` : ""}</div>
          <div>
            <h4>${esc(item.product_title)}</h4>
            ${item.variant_title ? `<small>${esc(item.variant_title)}</small><br>` : ""}
            <div class="qty">
              <button type="button" data-line="${i + 1}" data-qty="${item.quantity - 1}" aria-label="Færre">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-line="${i + 1}" data-qty="${item.quantity + 1}" aria-label="Flere">+</button>
            </div>
          </div>
          <div class="cart-item-price">${nok(item.final_line_price)}<button type="button" class="remove" data-line="${i + 1}" data-qty="0">Fjern</button></div>
        </li>`
          )
          .join("")
      : `<li class="cart-empty">Handlekurven er tom.</li>`;
  }

  async function refreshCart() {
    try { renderCart(await cartRequest("/cart.js")); } catch (err) { console.error(err); }
  }

  async function addToCart(p, variant, btn) {
    btn.disabled = true;
    try {
      await cartRequest("/cart/add.js", { items: [{ id: variant.id, quantity: 1 }] });
      await refreshCart();
      openCart(true);
    } catch (err) {
      toast(err.message);
    } finally {
      btn.disabled = false;
    }
  }

  $("#cartItems").addEventListener("click", async (e) => {
    const b = e.target.closest("[data-line]");
    if (!b) return;
    try {
      renderCart(await cartRequest("/cart/change.js", { line: Number(b.dataset.line), quantity: Number(b.dataset.qty) }));
    } catch (err) {
      toast(err.message);
    }
  });

  $("#checkoutBtn").addEventListener("click", (e) => {
    if (e.currentTarget.classList.contains("is-disabled")) e.preventDefault();
  });

  let lastFocus = null;
  drawer.inert = true;
  function openCart(open) {
    if (open === drawer.classList.contains("is-open")) return;
    if (open) lastFocus = document.activeElement;
    drawer.classList.toggle("is-open", open);
    drawer.setAttribute("aria-hidden", String(!open));
    drawer.inert = !open;
    if (open) $("#cartClose").focus();
    else if (lastFocus) lastFocus.focus({ preventScroll: true });
    $("#overlay").hidden = !open;
    document.body.style.overflow = open ? "hidden" : "";
  }

  let toastTimer;
  function toast(msg) {
    const t = $("#toast");
    t.textContent = msg;
    t.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("is-visible"), 2600);
  }

  $("#cartOpen").addEventListener("click", () => openCart(true));
  $("#cartClose").addEventListener("click", () => openCart(false));
  $("#overlay").addEventListener("click", () => openCart(false));
  document.addEventListener("keydown", (e) => e.key === "Escape" && openCart(false));

  refreshCart();
})();
